<template>
    <div class="pb-56 sm:pb-60 font-satoshi_r">
        <div class="flex flex-col justify-end items-center">

            <div class="flex flex-col items-center mb-36">
                <div class="flex justify-center items-center spinner-bg rounded-full w-10 h-10">
                    <lord-icon
                        src="https://cdn.lordicon.com/wpequvda.json"
                        trigger="loop"
                        state="loop-transparency"
                        colors="primary:#34bf72"
                        style="width:24px;height:24px"
                    >
                    </lord-icon>
                </div>

                <h3 class="text-1xl font-medium text-cream-500 pt-1 pb-2">
                    Loading...
                </h3>

                <p class="text-base font-medium text-gray-x10">
                    Please wait
                </p>
            </div>


            <div class="flex items-center space-x-2">
                <span class="text-xs text-gray-x10 font-satoshi_r">
                    Powered by
                </span>
                <div class="w-18r">
                    <img src="@/assets/images/trendupp/sycamore_logo.png" alt="Sycamore Logo">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },

    data() {
        return {
        }
    },

    methods: {
    },

    mounted() {
    },
};
</script>

<style scoped>
    .spinner-bg {
		background: linear-gradient(0deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%), #0C0C0C;
	}

    .text-1xl {
        font-size: 1.375rem /* 22px */ ;
        line-height: 2rem /* 32px */ ;
    }
</style>
